export default __webpack_public_path__ + "static/media/z070di0b.ac4181b9.mp3";